import { Box, Button, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import { regularTextColor, titleTextColor } from 'assets/styles/_palette';

export const ModalContent = styled(Box)({
	...flexMixin({ direction: 'column', gap: 32, align: 'center', justify: 'start' }),
	margin: '48px 0',
	position: 'relative',
	width: '100%',
	height: '100%',
	padding: '0 12px',
	boxSizing: 'border-box',
	overflow: 'auto',
});

export const StickyHeader = styled(Box)({
	position: 'sticky',
	top: 0,
	zIndex: 10,
	width: '100%',
	backgroundColor: '#FFF',
	paddingTop: '12px',
	paddingBottom: '12px',
	marginBottom: '20px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	backdropFilter: 'blur(8px)',
	boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
});

export const ModalTitle = styled(Typography)({
	fontSize: '24px',
	fontWeight: 700,
	lineHeight: '133.4%',
	color: titleTextColor,
});

export const ModalSubtitle = styled(Typography)({
	fontSize: '16px',
	fontWeight: 700,
	lineHeight: '157%',
	letterSpacing: '0.1px',
	color: titleTextColor,
});

export const ModalMainContent = styled(Box)({
	...flexMixin({ justify: 'flex-start', direction: 'column', gap: 24 }),
	width: '100%',
});

export const ModalUsers = styled(Box)({
	...flexMixin({ justify: 'flex-start', align: 'flex-start', direction: 'column', gap: 16 }),
	width: '100%',
	maxHeight: '440px',
	overflowY: 'auto',
});

export const InputsContainer = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	width: '100%',
	gap: '48px',
});

export const SingleInputContainer = styled(Box)({
	width: '33%',
	maxWidth: '300px',
});

export const SingleInputTitle = styled(Typography)({
	fontSize: '14px',
	color: regularTextColor,
	marginBottom: '4px',
});

export const ShareButton = styled(Button)({
	marginTop: '16px',
	height: '44px',
	width: '133px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	minWidth: '240px',
});

export const BackButton = styled(Button)({
	position: 'absolute',
	top: '12px',
	left: '12px',
	textTransform: 'none',
	fontWeight: '700',
	display: 'flex',
	gap: '4px',
	zIndex: 11,
});

export const SharesContainer = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	width: '80%',
	gap: '16px',
});

export const SharesTitle = styled(Typography)({
	color: titleTextColor,
	fontWeight: 700,
	fontSize: '14px',
});

export const SharesItemsContainer = styled(Box)({
	display: 'flex',
	gap: '16px',
	flexDirection: 'column',
});

export const SharesButtonsContainer = styled(Box)({
	display: 'flex',
	justifyContent: 'flex-end',
	gap: '16px',
	paddingTop: '16px',
});

export const ShareActionButton = styled(Button)({
	height: '44px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '14px',
	fontWeight: '700',
	minWidth: '240px',
});
